import { combineReducers } from 'redux';
import list from "./list";
import forms from "./forms";
import template from "./template";

export default combineReducers({
  list,
  forms,
  template,
});
